import React, { Component } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import Immutable from 'immutable';

import Loading from 'components/Component/Loading';
import StockChart from 'components/StockChart';

import * as GraphdataUtils from 'utils/graphdata';

import { componentId } from './OverviewChart';

class Chart extends Component {
  static propTypes = {};

  shouldComponentUpdate(nextProps) {
    return !nextProps.graphdata.equals(this.props.graphdata);
  }

  render() {
    const { graphdata: data, name } = this.props;

    const isFetching = data.get('isFetching');
    const series = GraphdataUtils.buildChartSeries(data);
    series.gapSize = 0;
    series.name = name;
    const breaks = GraphdataUtils.getBreaks(data);

    return (
      <div className={classNames('Chart', { fetching: isFetching })}>
        <Loading visible={isFetching} />
        <StockChart series={series} breaks={breaks} />
      </div>
    );
  }
}

function mapStateToProps(state) {
  let componentState = state.graphdata.get(componentId);
  if (!componentState) {
    componentState = Immutable.Map();
  }
  return { graphdata: componentState };
}

export default connect(mapStateToProps)(Chart);
